<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">
        Workflow Configuration
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <button class="btn btn-primary mr-1" @click="close()"><i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row>
        <b-col lg="7">
          <b-input-group>
            <b-input-group-prepend><span class="p-2">Workflow Name</span></b-input-group-prepend>
            <b-form-input v-model="tblData.wftypekey" @keyup.13.native="refresh()"></b-form-input>
            <b-input-group-append>
              <b-button class="btn btn-success ml-3" @click="search()"> <i class="fa fa-refresh"></i> Apply Filter</b-button>
            </b-input-group-append>
            <b-input-group-append>
              <b-button class="btn btn-secondary ml-1" @click="clearFilter()"> <i class="fa fa-eraser"></i>Clear Filter</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>

      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive
        hover
        small
        style="font-size: smaller"
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        @row-clicked="rowClicked"
      >
        <template v-slot:cell(index)="data">
          {{ (tblData.page - 1) * tblData.limit + data.index + 1 }}
        </template>
        <template v-slot:cell(escalateDays)="data"> {{ data.item.escalateDays }} days </template>
        <template v-slot:cell(organApproval)="data">
          <div v-if="data.item.organApproval == 1">
            <p v-if="data.item.isRequireSpv == 0 && data.item.isRequireMgr == 0 && data.item.isRequireDir == 0 && data.item.isRequireDirut == 0" class="m-0">Yes</p>
            <p v-if="data.item.isRequireSpv == 1" class="m-0">Supervisor Approval</p>
            <p v-if="data.item.isRequireMgr == 1" class="m-0">Manager Approval</p>
            <p v-if="data.item.isRequireDir == 1" class="m-0">Director Approval</p>
            <p v-if="data.item.isRequireDirut == 1" class="m-0">President Director Approval</p>
          </div>
        </template>
        <template v-slot:cell(functionApproval)="data">
          <span v-if="data.item.functionApproval == 1">Yes</span>
        </template>

        <template v-slot:cell(action)="data">
          <div class="text-center">
            <a href="javascript:void(0)" @click.stop="edit(data.item)">
              <i class="fa fa-pencil"></i>
            </a>
            |
            <a href="javascript:void(0)" class="text-danger" @click.stop="deleteConfirm(data.item)">
              <i class="fa fa-trash"></i>
            </a>
          </div>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="6">
          <div>
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }} to <span v-if="tblData.page * tblData.limit > tblData.total">{{ tblData.total }}</span>
            <span v-else>{{ tblData.page * tblData.limit }}</span> of {{ tblData.total }} entries
          </div>
        </b-col>
        <b-col cols="6">
          <b-pagination align="right" :total-rows="tblData.total" :per-page="tblData.limit" v-model="tblData.page"></b-pagination>
        </b-col>
      </b-row>

      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <b-row class="justify-content-center" v-if="showForm">
      <b-col md="12" lg="8">
        <b-card>
          <div slot="header">Workflow Configuration - Add/Edit Form</div>
          <b-input-group>
            <b-input-group-prepend><label>Workflow Name</label></b-input-group-prepend>
            <b-form-input v-model="frmdata.wftypekey" :state="!$v.frmdata.wftypekey.$error"></b-form-input>
            <b-form-checkbox :value="1" :unchecked-value="0" v-model="frmdata.isActive" class="mt-1">Active</b-form-checkbox>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>&nbsp;</label></b-input-group-prepend>
            <b-form-checkbox :value="1" :unchecked-value="0" v-model="frmdata.isTask" class="mt-1">it's Task</b-form-checkbox>
            <b-form-checkbox :value="1" :unchecked-value="0" v-model="frmdata.postponeAble" class="mt-1">Postponeable/Queued</b-form-checkbox>
            <b-input-group-append><span class="input-group-text ml-2">Waiting befor Escalated</span></b-input-group-append>
            <b-form-input v-model="frmdata.escalateDays" type="number"></b-form-input>
            <b-input-group-append><span class="input-group-text">Days</span></b-input-group-append>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>First Owner/Approver</label></b-input-group-prepend>
            <b-form-input v-model="frmdata.firstOwner" placeholder="CSV of Approver's Username"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>Organization Approval</label></b-input-group-prepend>
            <b-form-checkbox :value="1" :unchecked-value="0" v-model="frmdata.organApproval" class="mt-1">Yes</b-form-checkbox>
            <b-input-group-append><span class="pt-1 pl-2 mr-1">Required:</span></b-input-group-append>
            <b-form-checkbox :value="1" :unchecked-value="0" v-model="frmdata.isRequireSpv" class="mt-1" :disabled="!(frmdata.organApproval == '1')">Supervisor</b-form-checkbox>
            <b-form-checkbox :value="1" :unchecked-value="0" v-model="frmdata.isRequireMgr" class="mt-1 ml-1" :disabled="!(frmdata.organApproval == '1')">Manager</b-form-checkbox>
            <b-form-checkbox :value="1" :unchecked-value="0" v-model="frmdata.isRequireDir" class="mt-1 ml-1" :disabled="!(frmdata.organApproval == '1')">Director</b-form-checkbox>
            <b-form-checkbox :value="1" :unchecked-value="0" v-model="frmdata.isRequireDirut" class="mt-1 ml-1" :disabled="!(frmdata.organApproval == '1')">President Director</b-form-checkbox>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>Functional Approval</label></b-input-group-prepend>
            <b-form-checkbox :value="1" :unchecked-value="0" v-model="frmdata.functionApproval" class="mt-1">Yes</b-form-checkbox>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>Threshold Amount</label></b-input-group-prepend>
            <b-form-radio-group class="mt-2" v-model="frmdata.threshold_apply">
              <b-form-radio value="1">Applied</b-form-radio>
              <b-form-radio value="0">Not </b-form-radio>
            </b-form-radio-group>
            <b-input-group-prepend
              ><span class="input-group-text" style="width: 60px">{{ uanguser }}</span></b-input-group-prepend
            >
            <my-number
              class="form-control text-right ml-1"
              separator=","
              v-model="frmdata.thresholdAmt"
              :state="!$v.frmdata.thresholdAmt.$error"
              :disabled="frmdata.threshold_apply != 1"
              :precision="2"
            ></my-number>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend v-if="frmdata.threshold_apply == 1"><label style="width: 225px !important">Final Approver under Threshold</label></b-input-group-prepend>
            <b-input-group-prepend v-else><label>Final Approver</label></b-input-group-prepend>
            <b-form-input v-model="frmdata.finalOwner" placeholder="CSV of Approver's Username"></b-form-input>
          </b-input-group>
          <b-input-group v-if="frmdata.threshold_apply == 1">
            <b-input-group-prepend><label style="width: 225px !important ;">Final Approver exceed Threshold</label></b-input-group-prepend>
            <b-form-input v-model="frmdata.threshold_finalOwner" placeholder="CSV of Approver's Username"></b-form-input>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend><label style="width: 225px">Email On Completed</label></b-input-group-prepend>
            <b-form-input v-model="frmdata.emailOnComplete" placeholder="CSV of Emails"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label style="width: 225px">Exec.SQL On Completed</label></b-input-group-prepend>
            <b-form-input v-model="frmdata.actionOnComplete" placeholder="Query/Store Procedure with 1 parameter"></b-form-input>
          </b-input-group>
          <div slot="footer" style="text-align: center">
            <button class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
            <b-button variant="secondary" class="mr-1" @click="closeFrm()"> <i class="fa fa-close"></i> Close Form</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<style lang="scss">
.input-group {
  padding-bottom: 2px;
  .input-group-prepend {
    label {
      padding-top: 5px;
      padding-right: 5px;
      width: 160px;
    }
  }
}
</style>

<script>
import toastr from "mini-toastr";
import myNumber from "../../components/my-number";
import wfname from "../../apis/workflow";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {
  components: { myNumber },
  mixins: [validationMixin],
  validations: {
    frmdata: {
      wftypekey: { required },
      thresholdAmt: {
        required: function () {
          if ((this.model.threshold_apply || 0) == 0) {
            return true;
          } else if ((this.model.thresholdAmt || 0) == 0) {
            return false;
          } else return true;
        },
      },
    },
  },
  data() {
    return {
      showDelConfirm: false,
      showList: true,
      showForm: false,
      frmdata: {
        wftypekey: "",
        isTask: 0,
        firstOwner: "",
        finalOwner: "",
        functionApproval: 0,
        organApproval: 0,
        isRequireDir: 0,
        isRequireDirut: 0,
        postponeAble: 0,
        escalateDays: 1,
        thresholdAmt: 0,
        threshold_apply: 0,
        threshold_finalOwner: "",
      },
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "wftypekey",
        sortDesc: false,
      },
    };
  },
  computed: {
    tblFields() {
      const fields = [
        {
          key: "index",
          label: "No.",
          thStyle: "width:30px",
        },
        {
          key: "wftypekey",
          label: "Job Type Name",
          sortable: true,
        },
        {
          key: "isActive",
          label: "Active",
          thStyle: "width:40px",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "postponeAble",
          label: "Postponeable",
          thStyle: "width:60px",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "escalateDays",
          label: "Escalate",
          thStyle: "width:60px",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "firstOwner",
          label: "First Approver",
          sortable: true,
        },
        {
          key: "organApproval",
          label: "Organization Approval",
          sortable: true,
        },
        {
          key: "functionApproval",
          label: "Functional Approval",
          sortable: true,
        },
        {
          key: "finalOwner",
          label: "Final Approver",
          sortable: true,
        },
        {
          key: "emailOnComplete",
          label: "Email On Completed",
          sortable: true,
        },
        {
          key: "action",
          label: "Action",
          thStyle: "width:60px",
          thClass: "text-center",
        },
      ];
      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
    organApproval() {
      return this.frmdata.organApproval;
    },
    uanguser() {
      return this.$store.state.user.matauang;
    },
  },
  watch: {
    organApproval(newval) {
      if (newval == 0) {
        this.frmdata.isRequireDir = 0;
        this.frmdata.isRequireDirut = 0;
      }
    },
  },
  methods: {
    data: async function (ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

      const list = await wfname.list(this.tblData);
      return list;
    },
    search() {
      this.tblData.page = 1;
      this.refresh();
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    clearFilter(ctx) {
      this.tblData.wftypekey = "";
      this.refresh();
    },

    add: function (data) {
      for (var key in this.frmdata) {
        this.frmdata[key] = "";
      }
      this.frmdata.isTask = 0;
      this.frmdata.postponeAble = 0;
      this.frmdata.escalateDays = 1;
      this.frmdata.organApproval = 0;
      this.frmdata.isRequireDir = 0;
      this.frmdata.isRequireDirut = 0;
      this.frmdata.functionApproval = 0;
      this.showForm = true;
      this.showList = false;
    },
    edit: async function (data) {
      this.model = data;
      for (var key in this.frmdata) {
        this.frmdata[key] = "";
      }
      for (var key in this.model) {
        this.frmdata[key] = this.model[key];
      }
      this.frmdata.idlama = data.wftypekey;
      this.frmdata.threshold_apply = this.frmdata.threshold_apply || 0;
      this.showForm = true;
      this.showList = false;
    },
    save: async function (callback) {
      if (this.invalidFormdata) {
        console.log("validation : ", this.$v.frmdata);
        console.log("frmdata : ", this.frmdata);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        try {
          await wfname.save(this.frmdata);
          this.closeFrm();
          setTimeout(() => {
            this.refresh();
          }, 500);
        } catch (error) {
          console.log("error : ", error);
          if (error.sql) {
            toastr.error(error.sql, "ERROR MESSAGE", 10000);
          } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
          } else if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      }
    },
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function () {
      await wfname.remove(this.model);
      this.refresh();
    },
    rowClicked(record, index) {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
    },
    closeFrm() {
      this.showForm = false;
      this.showList = true;
    },
    close() {
      router.push("home");
    },
  },
};
</script>
